/**
 * @Description 选址地图详情-左侧地图
 */

import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { Typography } from 'antd';
import { useMethods } from '@lhb/hook';
// import cs from 'classnames';
import styles from './index.module.less';
// 使用组件库的地图组件，逐步替换
import V2AMap from '@/common/components/Map/V2AMap';
import Legend from './Legend';
import Rail from './Rail';
import BackCore from './BackCore';
// import MarkerCluster from './MapPoint/MarkerCluster';
import CompetitorsMarker from './MapPoint/CompetitorsMarker';
import FamousMarker from './MapPoint/FamousMarker';
import StoreBrandMarker from './MapPoint/StoreBrandMarker';
import CommonRimMarker from './MapPoint/CommonRimMarker';
import StandardShop from './MapPoint/StandardShop';
import Chancepoint from './MapPoint/Chancepoint';
import cs from 'classnames';
import { debounce } from '@lhb/func';
import { useBigdataFn } from '@/common/utils/bigdata';
import { useSelector } from 'react-redux';
import { demoForCarModelIds } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import GatherClientMap from './MapPoint/GatherClientMap';
import { defaultMapStyle } from '@/layout/ts-config';
export const mapContainer = 'mapContainer';
const { Text } = Typography;
const FirstScreenMap: FC<any> = ({
  mapIns,
  detail,
  mainHeight,
  chancepointAlias,
  legendData,
  isMallType,
  storeChecked,
  surroundingChecked,
  // modelConfigId,
  setMapIns,
  // curSurroundDetail, // 周边配套选中的表格项
  // setCurSurroundDetail, // 设置周边配套选中的表格项
  curDetail, // 经营门店选中的表格项
  setCurDetail, // 设置经营门店选中的表格项
  rangeMarkerRef,
  isOpenHeatMap,
  gatherClientLegendList,
  isShare,
  shareParams,
  mapConfig,
}) => {
  const modelConfigId = useSelector((state: any) => state.iterate.modelConfigId); // 存放选址地图页面的当前模型

  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [isBack, setIsBack] = useState(false);
  const [famousBrandData, setFamousBrandData] = useState<any[]>([]); // 知名品牌数据
  const [competitorsData, setCompetitorsData] = useState<any[]>([]); // 竞品数据
  const [commonStoreData, setCommonStoreData] = useState<any>({}); // 经营门店
  const [commonRimData, setCommonRimData] = useState<any>({}); // 周边配套数据
  const [standardShopData, setStandardShopData] = useState<any[]>([]); // 本品牌门店
  const [chancepointData, setChancepointData] = useState<any[]>([]); // 机会点
  const [isOpenGatherClient, setIsOpenGatherClient] = useState<boolean>(false);
  // const [isShowZoom, setIsShowZoom] = useState<boolean>(false);// 是否到展示知名品牌、竞品品牌、经营门店的聚合的级别
  const contentMarkerRef = useRef<any>(null);
  // const isShowCluster = useMemo(() => {
  //   // if (!isShowZoom) return false;
  //   const count = (famousBrandData?.length || 0) +
  //   (competitorsData?.length || 0) +
  //   Object.keys(commonStoreData)?.reduce((acc, key) => {
  //     return acc + (commonStoreData[key].length || 0);
  //   }, 0);
  //   // 是否聚合
  //   const isCluster = count > 60 && isShowZoom;
  //   // 如果之前打开了经营门店的context，在聚合级别下不展示
  //   if (isCluster && contentMarkerRef.current?.getExtData()?.isStore) {
  //     mapIns.remove(contentMarkerRef.current);
  //     setCurDetail(null);
  //   }
  //   // 当视图为3km的地图比例尺，且500m以内的经营门店数超过60家则显示小聚合
  //   return isCluster;
  // }, [famousBrandData, competitorsData, commonStoreData, isShowZoom]);

  const address = useMemo(() => {
    const {
      resourceMallFlag,
      centerAddress,
      provinceName,
      cityName,
      districtName
    } = detail || {};
    if (resourceMallFlag) {
      let str = '';
      if (provinceName && provinceName !== cityName) {
        str += provinceName;
      }
      if (cityName) str += cityName;
      if (districtName) str += districtName;
      if (centerAddress) str += centerAddress;
      return str;
    }
    return centerAddress;
  }, [detail]);
  const handleDetailToNull = () => {
    setCurDetail(null);
    // setCurSurroundDetail(null);
  };
  const methods = useMethods({
    mapLoadedHandle: (ins: any) => {
      setMapIns(ins);
      // ins.setZooms([13.5, 20]);
    },
    onClickMarker() {
      bigdataFn('4e6abada-ed03-4719-b8f6-237cee100584', '详情-地图-点击图标', '点击了详情-地图-点击图标', { op_block: '开店区域-详情页', op_event: ``, });
    },
    handlerZoomEnd: debounce(() => {
      bigdataFn('4cf4ecd1-17e0-4f08-bc4f-dd199ef80125', '详情-地图-放大/缩小一次', '详情-地图-放大/缩小一次', { op_block: '开店区域-详情页', op_event: ``, });
    }, 200),
    handlerMoveend: debounce(() => {
      bigdataFn('1392958f-a3fa-4db6-a9e6-afec91b43486', '详情-地图-拖动一次', '详情-地图-拖动一次', { op_block: '开店区域-详情页', op_event: ``, });
    }, 200),
  });

  // const handlerZoomEnd = debounce(() => {
  //   bigdataFn('4cf4ecd1-17e0-4f08-bc4f-dd199ef80125', '详情-地图-放大/缩小一次', '详情-地图-放大/缩小一次', { op_block: '开店区域-详情页', op_event: ``, });
  // }, 200);
  // const handlerMoveend = debounce(() => {
  //   bigdataFn('1392958f-a3fa-4db6-a9e6-afec91b43486', '详情-地图-拖动一次', '详情-地图-拖动一次', { op_block: '开店区域-详情页', op_event: ``, });
  // }, 200);

  useEffect(() => {
    // 如果curDetail为空，则移出contentMarkerRef
    if (!curDetail) {
      contentMarkerRef.current && mapIns?.remove(contentMarkerRef.current);
    }
  }, [curDetail]);

  useEffect(() => {
    if (!mapIns) return;
    mapIns.on('zoomend', methods.handlerZoomEnd);
    mapIns.on('moveend', methods.handlerMoveend);

    return () => {
      mapIns?.off?.('zoomend', methods.handlerZoomEnd);
      mapIns?.off?.('moveend', methods.handlerMoveend);
    };
  }, [mapIns]);

  return (
    <div className={styles.firstScreenMapCon}>
      <div className={cs(styles.mapContainer, mapContainer)}>
        <V2AMap
          mapOpts={{
            zooms: [demoForCarModelIds.includes(modelConfigId) ? 10 : 13.5, 20],
            showIndoorMap: true,
            mapStyle: `amap://styles/${mapConfig?.bg || defaultMapStyle}`
          }}
          loaded={methods.mapLoadedHandle}
        >
          {/* 图例 */}
          <Legend
            isMallType={isMallType}
            detail={detail}
            mainHeight={mainHeight}
            legendData={legendData}
            storeChecked={storeChecked}
            surroundingChecked={surroundingChecked}
            setStandardShopData={setStandardShopData}
            setChancepointData={setChancepointData}
            setCompetitorsData={setCompetitorsData}
            setFamousBrandData={setFamousBrandData}
            setCommonStoreData={setCommonStoreData}
            setCommonRimData={setCommonRimData}
            isOpenHeatMap={isOpenHeatMap}
            modelConfigId={modelConfigId}
            setIsOpenGatherClient={setIsOpenGatherClient}
            isShare={isShare}
            shareParams={shareParams}
          />
          {/* 商圈围栏以及默认的围栏 */}
          <Rail
            mapIns={mapIns}
            detail={detail}
            isBack={isBack}
            setIsBack={setIsBack}
            rangeMarkerRef={rangeMarkerRef}
          />
          {/* 本品牌门店 */}
          <StandardShop
            mapIns={mapIns}
            legendData={legendData}
            data={isOpenHeatMap ? [] : standardShopData}
            contentMarkerRef={contentMarkerRef}
            onClickMarker={methods.onClickMarker}
          />
          {/* 机会点 */}
          <Chancepoint
            mapIns={mapIns}
            legendData={legendData}
            chancepointAlias={chancepointAlias}
            data={isOpenHeatMap ? [] : chancepointData}
            contentMarkerRef={contentMarkerRef}
            onClickMarker={methods.onClickMarker}
          />
          {/* 回到商圈重心位置 */}
          <BackCore
            setIsBack={setIsBack}
          />
          {/* 知名品牌 */}
          <FamousMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? [] : famousBrandData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            onClickMarker={methods.onClickMarker}
          />
          {/* 竞品门店 */}
          <CompetitorsMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? [] : competitorsData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            onClickMarker={methods.onClickMarker}
          />
          {/* 经营门店（除知名品牌、竞品门店外） */}
          <StoreBrandMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? {} : commonStoreData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            onClickMarker={methods.onClickMarker}
          />
          {/* 周边配套数据 */}
          <CommonRimMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? {} : commonRimData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            onClickMarker={methods.onClickMarker}
          />
          <GatherClientMap
            mapIns={mapIns}
            gatherClientLegendList={
              // 打开热力不显示
              isOpenHeatMap ? []
              // 打开图例才显示
                : (isOpenGatherClient ? gatherClientLegendList : [])
            }
          />
          {/* 经营门店点聚合 */}
          {/* <MarkerCluster
            mapIns={mapIns}
            famousBrandData={famousBrandData}
            competitorsData={competitorsData}
            commonStoreData={commonStoreData}
            isShowCluster={isShowCluster}
            setIsShowZoom={setIsShowZoom}
            legendData={legendData}
          /> */}
        </V2AMap>
      </div>
      <div className={styles.addressCon}>
        <Text
          style={{ width: 650 }}
          ellipsis={{ tooltip: address }}>
          <span className='c-999 fs-14'>
            地址：{address}
          </span>
        </Text>
      </div>
    </div>
  );
};

export default FirstScreenMap;
